import { render, staticRenderFns } from "./QuickAddTask.vue?vue&type=template&id=1785b838&"
import script from "./QuickAddTask.vue?vue&type=script&lang=ts&"
export * from "./QuickAddTask.vue?vue&type=script&lang=ts&"
import style0 from "./QuickAddTask.vue?vue&type=style&index=0&id=1785b838&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports